import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const HeaderDialogNested = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1.5),
}));
